export const AuthConstants = {
  KEYS: {
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    USER_DATA: "user_data",
    AUTH_SOURCE: "auth_source",
    AUTHORITIES: "authorities",
    OKTA_ACCESS_TOKEN: "okta_access_token",
    OKTA_REFRESH_TOKEN: "okta_refresh_token"
  },
  SOURCES: {
    CREDENTIALS: "credentials",
    OKTA: "okta"
  },
  OKTA_STORAGE_KEYS: [
    "okta-token-storage",
    "okta-cache-storage",
    "okta-pkce-storage",
    "okta-transaction-storage",
    "okta-shared-transaction-storage",
    "okta-original-uri-storage",
    "okta-idx-response-storage"
  ]
};
